import { parseAsString } from 'nuqs'

export enum QueryParamsType {
  orderId = 'orderId',
  productId = 'productId',
  SDAlert = 'SDAlert',
  redirectTo = 'redirectTo',
  pickingId = 'pickingId',
  movementId = 'movementId',
}

export const queryParamsSerializer = {
  orderId: parseAsString,
  productId: parseAsString,
  SDAlert: parseAsString,
  redirectTo: parseAsString,
  pickingId: parseAsString,
  movementId: parseAsString,
}
